enum StudentStage {
  ENROLLMENT = 'enrollment',
  STUDY_PLAN = 'study-plan',
  SCHEDULE = 'schedule',
  ENROLLED = 'enrolled',
  PAID = 'paid',
  COMMENTS = 'comments',
}

export {
  StudentStage,
};
